import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { ProjetosService } from '../services/projetos/projetos.service';
import { ToastService } from '../services/toast/toast.service';

export const podeEditarProjetoGuard: CanActivateFn = (route) => {
  const projetosService = inject(ProjetosService);
  const router = inject(Router);
  const toastService = inject(ToastService);
  const id = route.paramMap.get('id');

  return projetosService.getProjetoEdicao(id).pipe(
    map(() => true),
    catchError((erro: any) => {
      toastService.showError(erro?.error?.message ?? 'Não foi possível acessar a edição deste projeto.');
      return of(router.createUrlTree(['projetos']));
    })
  );
};
